import React from "react";
import { motion } from "framer-motion";

const PolicyLayout = ({ title, children }) => {
  return (
    <div className="bg-white min-h-screen pt-10 pb-20">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-black text-gray-dark mb-8 tracking-tight">
            {title}
          </h1>
          <div className="prose prose-orange max-w-none text-gray-600 leading-relaxed space-y-6 font-medium">
            {children}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

const TermsConditions = () => {
  return (
    <PolicyLayout title="Terms & Conditions">
      <p>Welcome to Khajuraho Routes. By booking a tour with us, you agree to the following terms and conditions that govern our travel services in Khajuraho and Central India.</p>
      
      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">1. Booking & Payments</h2>
        <p>A booking is considered confirmed only after receipt of the required advance payment. The remaining balance must be cleared before or upon arrival in Khajuraho, as per the agreement at the time of booking.</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">2. Sightseeing & Monuments</h2>
        <p>Entrance fees to the Western, Eastern, and Southern groups of temples in Khajuraho, Light and Sound shows, and other monuments are generally not included in the package unless explicitly mentioned. Guests are required to carry a valid ID proof for entry.</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">3. Conduct During Tours</h2>
        <p>Travelers are expected to follow the instructions of the tour guide and respect the local culture and sanctity of the temples. Khajuraho Routes reserves the right to terminate the service of any traveler whose behavior is disruptive or illegal.</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">4. Liability</h2>
        <p>While we take every precaution to ensure your safety, Khajuraho Routes is not liable for any personal injury, loss of luggage, or delays caused by factors beyond our control, such as traffic, weather, or political strikes.</p>
      </section>

      <section>
        <h2 className="text-2xl font-bold text-gray-dark mt-8 mb-4">5. Jurisdiction</h2>
        <p>Any disputes arising out of these terms shall be subject to the exclusive jurisdiction of the courts in Chhatarpur/Khajuraho, Madhya Pradesh.</p>
      </section>
    </PolicyLayout>
  );
};

export default TermsConditions;
